import { apiEndPoint } from '../../environment';
import axios from 'axios';


let cancleToken = axios.CancelToken.source();

export function getRequest(urlEndPoint) {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${apiEndPoint}${urlEndPoint}`,
        headers: {
            'Content-Type': 'application/json'
        },
        cancleToken: cancleToken.token,
    };

    return axios.request(config)
}

export function postRequest(urlEndPoint, data, header = { 'Content-Type': 'application/json' }) {
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiEndPoint}${urlEndPoint}`,
        headers: header,
        data: data,
        cancleToken: cancleToken.token,
    };

    return axios.request(config)
}

export function updateRequst(urlEndPoint, data, access) {
    let config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: `${apiEndPoint}${urlEndPoint}`,
        headers: {
            'x-access-token': access,
            'Content-Type': 'application/json'
        },
        data: data,
        cancleToken: cancleToken.token,
    };

    return axios.request(config)
}

export function updatePatchRequst(urlEndPoint, data) {
    let config = {
        method: 'patch',
        maxBodyLength: Infinity,
        url: `${apiEndPoint}${urlEndPoint}`,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data,
        cancleToken: cancleToken.token,
    };

    return axios.request(config)
}

export function updatePutRequst(urlEndPoint, data) {
    let config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: `${apiEndPoint}${urlEndPoint}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data,
        cancleToken: cancleToken.token,
    };

    return axios.request(config)
}